/**
 * An event dispatched by PostMessageManager.
 */
export class PostMessageEvent {
}

PostMessageEvent.RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';